import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
interface NumericRouteProps {
    children: ReactNode;
}

const NumericRoute = ({ children }: NumericRouteProps) => {
    const location = useLocation();
    const pathname = location.pathname;

    if (!pathname || !/^\/\d+.*/.test(pathname)) {
        return <Navigate to="/not-found" replace />;
    }

    return <>{children}</>;
};

export default NumericRoute;
